import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import PageLayout from './PageLayout';
import PageToggleTransition from '../components/transition/PageToggleTransition';
import { mapState } from 'vuex';
export default {
  name: 'PageView',
  components: {
    PageLayout: PageLayout,
    PageToggleTransition: PageToggleTransition
  },
  data: function data() {
    return {
      page: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('setting', ['isMobile', 'multiPage', 'animate'])), {}, {
    desc: function desc() {
      return this.page.desc;
    },
    linkList: function linkList() {
      return this.page.linkList;
    },
    extraImage: function extraImage() {
      return this.page.extraImage;
    }
  }),
  mounted: function mounted() {
    this.page = this.$refs.page;
  },
  updated: function updated() {
    this.page = this.$refs.page;
  }
};